/* ==========================================================================
   MyPresente — theme.js
   Vanilla JS. No build step required.
   ========================================================================== */
(function () {
  "use strict";

  /* ---------------- Header scroll compact ---------------- */
  var header = document.getElementById("site-header");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add("compact");
      else header.classList.remove("compact");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Mobile drawer ---------------- */
  var drawer = document.getElementById("mobile-drawer");
  var hamburger = document.getElementById("hamburger-toggle");
  var drawerClose = document.getElementById("drawer-close");

  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if (hamburger) hamburger.setAttribute("aria-expanded", open ? "true" : "false");
  }
  if (hamburger) hamburger.addEventListener("click", function () { toggleDrawer(true); });
  if (drawerClose) drawerClose.addEventListener("click", function () { toggleDrawer(false); });
  if (drawer) {
    drawer.querySelectorAll(".drawer-link").forEach(function (a) {
      a.addEventListener("click", function () { toggleDrawer(false); });
    });
  }

  /* ---------------- Search overlay ---------------- */
  var searchOverlay = document.getElementById("search-overlay");
  var searchToggle = document.getElementById("search-toggle");

  function toggleSearch(open) {
    if (!searchOverlay) return;
    searchOverlay.classList.toggle("hidden", !open);
    if (searchToggle) searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      var input = document.getElementById("search-input");
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  }
  if (searchToggle) searchToggle.addEventListener("click", function () { toggleSearch(true); });
  if (searchOverlay) {
    searchOverlay.addEventListener("click", function (e) {
      if (e.target === searchOverlay) toggleSearch(false);
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      toggleSearch(false);
      toggleDrawer(false);
    }
  });

  /* ---------------- Collection filter drawer (mobile) ---------------- */
  var filtersToggle = document.getElementById("filters-toggle");
  var filtersPanel = document.getElementById("filters-panel");
  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener("click", function () {
      filtersPanel.classList.toggle("open");
    });
  }

  /* Auto-submit facet filters on change (progressive enhancement) */
  var facetForm = document.getElementById("FacetFiltersForm");
  if (facetForm) {
    facetForm.addEventListener("change", function () {
      var params = new URLSearchParams(window.location.search);
      var formData = new FormData(facetForm);
      // Clear previous filter.* params, keep sort_by
      Array.from(params.keys()).forEach(function (key) {
        if (key.indexOf("filter.") === 0) params.delete(key);
      });
      formData.forEach(function (value, key) {
        if (value) params.append(key, value);
      });
      window.location.search = params.toString();
    });
  }

  /* ---------------- Product gallery thumbnails ---------------- */
  var mainImage = document.querySelector("[data-main-image]");
  var thumbs = document.querySelectorAll("[data-thumb]");
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var full = btn.getAttribute("data-full");
        var img = mainImage.querySelector("img");
        if (img && full) img.setAttribute("src", full);
      });
    });
  }

  /* ---------------- Product variant option buttons ---------------- */
  var productForm = document.getElementById("ProductForm");
  if (productForm) {
    var optButtons = productForm.querySelectorAll(".opt-btn");
    var variantInput = productForm.querySelector("[data-variant-id]");

    optButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest(".option-field");
        group.querySelectorAll(".opt-btn").forEach(function (b) { b.classList.remove("selected"); });
        btn.classList.add("selected");

        // Rebuild the URL with the new option selection and let Shopify resolve the variant.
        var selections = [];
        productForm.querySelectorAll(".option-field").forEach(function (field) {
          var active = field.querySelector(".opt-btn.selected");
          if (active) selections.push(active.getAttribute("data-option-value"));
        });
        var url = new URL(window.location.href);
        url.searchParams.set("variant_selection", selections.join(","));
        // Simplest robust approach: reload the product page with options as query params
        // matching Shopify's ?option-name=value pattern is theme-specific, so instead
        // we fetch the product's variants JSON and match locally.
        fetchVariantAndUpdate(selections);
      });
    });

    function fetchVariantAndUpdate(selections) {
      if (!window.__productVariants) return;
      var match = window.__productVariants.find(function (v) {
        return v.options.length === selections.length && v.options.every(function (val, i) { return val === selections[i]; });
      });
      if (match && variantInput) {
        variantInput.value = match.id;
        var priceEl = document.getElementById("ProductPrice");
        if (priceEl && match.price != null) {
          priceEl.textContent = formatMoney(match.price);
        }
      }
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return "₹" + amount.replace(/\.00$/, "");
    }
  }

  /* ---------------- Prefill quote form "product" field from ?product= ---------------- */
  var params = new URLSearchParams(window.location.search);
  var productParam = params.get("product");
  if (productParam) {
    var productField = document.getElementById("q-product");
    if (productField && !productField.value) productField.value = decodeURIComponent(productParam);
  }

  /* ---------------- Cart quantity change -> auto submit hint ---------------- */
  document.querySelectorAll(".qty-input").forEach(function (input) {
    input.addEventListener("change", function () {
      var form = input.closest("form");
      if (form) form.querySelector('[name="update"]') && form.requestSubmit && form.requestSubmit(form.querySelector('[name="update"]'));
    });
  });
})();
